import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 50 50\" id=\"icon-play\"><path d=\"M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25 11.193 0 25 0s25 11.193 25 25Z\" fill=\"#F1F2EF\" fill-opacity=\".25\" /><path d=\"M20 34.571V16l13 9.286-13 9.285Z\" fill=\"#fff\" stroke=\"#6E6E6E\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol